import { canUseDom } from '@argos/utils'

import config from '../Config'

export const isMobile = () => canUseDom() && window.outerWidth < config.breakpoints.tablet

export const isTablet = () =>
  canUseDom() && window.outerWidth >= config.breakpoints.tablet && window.outerWidth < config.breakpoints.desktop

export const isDesktop = () => canUseDom() && window.outerWidth >= config.breakpoints.desktop
